import React from 'react';
import './Certificates.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { certificate1, certificate2, certificate3, certificate4, certificate5, certificate6, certificate7, certificate8 } from '../../images';
import { AiOutlineShareAlt } from 'react-icons/ai';

const data = [
    {
        avatar: certificate1,
        title: 'Node.js',
        review: `Certified in Node.js, skilled in scalable web applications, event-driven programming, and leveraging the NPM ecosystem.`,
        demoLink: 'https://www.udemy.com/certificate/UC-aa3773be-eed5-4fcd-a71b-8b032d06326f'
    },
    {
        avatar: certificate2,
        title: 'React.js',
        review: `Certified in React, proficient in dynamic UI creation, state management, and building reusable components for web apps.`,
        demoLink: 'https://www.udemy.com/certificate/UC-3983f83b-9718-48ff-80c8-b6e838c4d48d'
    },
    {
        avatar: certificate3,
        title: '100 Days Badege 2024',
        review: `Earned 100 Days Badge 2024, showcasing dedication, consistent learning, and personal growth in acquiring new skills.`,
        demoLink: 'https://leetcode.com/u/Yassin-Al-Farwan'
    },
    {
        avatar: certificate4,
        title: '50 Days Badege 2024',
        review: `Earned 50 Days Badge 2024, showcasing dedication, consistent learning, and personal growth in acquiring new skills.`,
        demoLink: 'https://leetcode.com/u/Yassin-Al-Farwan'
    },
    {
        avatar: certificate5,
        title: 'Monthly Badge 2024',
        review: `Achieved May Badge 2024, demonstrating dedication to continuous learning and personal growth throughout the month.`,
        demoLink: 'https://leetcode.com/u/Yassin-Al-Farwan/'
    },
    {
        avatar: certificate6,
        title: 'HTML',
        review: `Proficient in HTML, skilled in structuring web content, creating user-friendly interfaces for seamless user experiences.`,
        demoLink:'https://online.publuu.com/532703/1193604'
    },
    {
        avatar: certificate7,
        title: 'CSS',
        review: `Certified in CSS, experienced in styling web pages, creating visually appealing layouts, and implementing responsive designs.`,
        demoLink:'https://online.publuu.com/532703/1193606'
    },
    {
        avatar: certificate8,
        title: 'JavaScript',
        review: `Proficient in JavaScript, creating interactive web experiences, and implementing dynamic functionality for user engagement.`,
        demoLink:'https://online.publuu.com/532703/1193612'
    },
];

const Certificates = () => {
    return (
        <section id='certificates'>
            <div className="section__wrapper">
                <div className="section__header">
                    <h2 className="primary__title">Certificates</h2>
                    <p className="text__muted description">
                        My extensive collection of certificates exemplify expertise, unwavering commitment, and resounding success across diverse domains, showcasing a wide range of skills and achievements.</p>
                </div>
                <Swiper
                    className='certificates__container'
                    modules={[Pagination]}
                    spaceBetween={40}
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                    breakpoints={{
                        700: {
                            slidesPerView: 2,

                        }
                    }}
                >
                    {data.map(({ avatar, title, review }, index) => {
                        return (
                            <>
                                <SwiperSlide className='certificates' key={index}>
                                    <h3 className="title">{title}</h3>
                                    <div className="client__avatar">
                                        <img src={avatar} alt={review} />
                                    </div>
                                    <small className="client__review">{review}</small>
                                    <div className="button__container">
                                    <a href={data[index].demoLink} target="_blank" rel="noopener noreferrer" className="btn btn__primary">Show</a>                                        <div className="btn__share"><AiOutlineShareAlt /></div>
                                    </div>
                                </SwiperSlide>
                            </>
                        );

                    })
                    }
                </Swiper>

            </div>
        </section>
    );
};

export default Certificates;